import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-800 text-white" data-id="element-171" data-mp="3geze367ujv27">
      <div className="container mx-auto px-4 py-12" data-id="element-172" data-mp="3ggtwodvnbb34">
        <div className="grid md:grid-cols-4 gap-8" data-id="element-173" data-mp="32oe3e4sjqrfe">
          <div data-id="element-174" data-mp="32pp57z2flp3v">
            <h3 className="text-xl font-bold mb-4" data-id="element-175" data-mp="32m1awxp5wyo3">
              <span className="text-teal-400" data-id="element-176" data-mp="36qhg0wqyc229">Cal</span>MiR
            </h3>
            <p className="text-gray-300 text-sm" data-id="element-177" data-mp="3ueiknul0eyce">
              California Institute for Microbiome Research
            </p>
            <p className="text-gray-400 text-sm mt-4" data-id="element-178" data-mp="37o38m5zzh95">
              Advancing Truth in Microbiome Science
            </p>
          </div>
          <div data-id="element-179" data-mp="3lggbgrr4gze1">
            <h4 className="font-bold mb-4" data-id="element-180" data-mp="3qdf2h1fhoq80">Quick Links</h4>
            <ul className="space-y-2" data-id="element-181" data-mp="3qbvojhhb2r9e">
              {['Home', 'Research Hub', 'Certification', 'About'].map(item => <li key={item} data-id="element-182" data-mp="2ey9wnok2abk6">
                    <a href={`/${item.toLowerCase().replace(/\s+/g, '-')}`} className="text-gray-300 hover:text-teal-400 transition-colors duration-200 text-sm" data-id="element-183" data-mp="2ezba1zojva52">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>
          <div data-id="element-184" data-mp="3q8wqns168kd8">
            <h4 className="font-bold mb-4" data-id="element-185" data-mp="3q83q58st2r3j">Resources</h4>
            <ul className="space-y-2" data-id="element-186" data-mp="3qaq0thaztmpz">
              {['Support Us', 'Media & Blog', 'Contact', 'Careers'].map(item => <li key={item} data-id="element-187" data-mp="34pafb4q00ju">
                    <a href={`/${item.toLowerCase().replace(/\s+/g, '-')}`} className="text-gray-300 hover:text-teal-400 transition-colors duration-200 text-sm" data-id="element-188" data-mp="33e3x3jw4ep1">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>
          <div data-id="element-189" data-mp="mspojpyemv6k">
            <h4 className="font-bold mb-4" data-id="element-190" data-mp="mt7rf5fko7ng">Legal</h4>
            <ul className="space-y-2" data-id="element-191" data-mp="tv4om5kz9a6l">
              {['Privacy Policy', 'Terms of Use', 'Accessibility'].map(item => <li key={item} data-id="element-192" data-mp="yuzbzz5jnhmw">
                    <a href={`/${item.toLowerCase().replace(/\s+/g, '-')}`} className="text-gray-300 hover:text-teal-400 transition-colors duration-200 text-sm" data-id="element-193" data-mp="ys3bc32baeur">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>
        </div>
        <div className="border-t border-navy-700 mt-8 pt-8 text-center text-gray-400 text-sm" data-id="element-194" data-mp="1hj4bguf64gfw">
          <p data-id="element-195" data-mp="1mkbhop1nx7kg">
            © {currentYear} California Institute for Microbiome Research. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}